import React from 'react';
import Partnership from '../components/Partnership';
import HowItWorks from '../components/HowItWorks';
import Monetization from '../components/Monetization';
const Telecoms = () => {
  return <div className="w-full min-h-screen bg-white" data-id="element-422">
      <div className="pt-8 bg-white" data-id="element-423">
        <div className="container mx-auto px-4 text-center" data-id="element-424">
          <h1 className="text-4xl font-bold mb-4" data-id="element-425">Telecom Partnerships</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8" data-id="element-426">
            Partner with Voxie to bring AI to the next billion users through
            your telecom infrastructure.
          </p>
        </div>
      </div>
      <Partnership data-id="element-427" />
      <HowItWorks data-id="element-428" />
      <Monetization data-id="element-429" />
    </div>;
};
export default Telecoms;